<template>
  <div>
    <div>
      <location-editor :payload="{ location, resource_type: 'Position', resource_id: payload.position_id }"></location-editor>
    </div>
  </div>
</template>
<script>
import LocationEditor from '@/components/LocationEditor'
export default {
  name: 'position-locations',
  props: ['payload'],
  data () {
    return {
      location: undefined
    }
  },
  created () {
    this.$network_utils.getResourceLocations({ current_type: 'Position', current_resource_id: this.payload.position_id }).then(response => {
      this.location = response[0]
    })
  },
  components: {
    LocationEditor
  }
}
</script>
